<template>
    <div class="package-size-selector">
        <div class="size-label">
            <v-icon small color="warning" class="mr-2">mdi-ruler</v-icon>
            <span class="label-text">Paketgröße:</span>
        </div>
        <div class="size-buttons">
            <v-btn
                @click="handleSizeChange(true)"
                :color="selectedSize === true ? 'primary' : ''"
                :outlined="selectedSize !== true"
                class="size-btn"
                small>
                <v-icon x-small left>mdi-package-variant-closed</v-icon>
                Unter 8cm
            </v-btn>
            <v-btn
                @click="handleSizeChange(false)"
                :color="selectedSize === false ? 'primary' : ''"
                :outlined="selectedSize !== false"
                class="size-btn"
                small>
                <v-icon x-small left>mdi-package-variant</v-icon>
                Über 8cm
            </v-btn>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PackageSizeSelector',
    props: {
        value: {
            type: [Boolean, Object],
            default: null
        }
    },
    data() {
        return {
            selectedSize: null  // null = unselected, true = under 8cm, false = over 8cm
        }
    },
    watch: {
        value(newVal) {
            this.selectedSize = newVal;
        }
    },
    methods: {
        handleSizeChange(value) {
            this.selectedSize = value;
            this.$emit('input', value);
            this.$emit('size-changed', value);
            // Store in localStorage like the EndlessPacklist version
            localStorage.setItem('under8cm', JSON.stringify(value));
        }
    },
    mounted() {
        // Don't load from localStorage - require fresh selection for workflow enforcement
        // User must actively select a size for each order
    }
}
</script>

<style scoped>
.package-size-selector {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 16px;
    background-color: #f8f9fa;
    border-top: 1px solid #e0e0e0;
    border-bottom: 1px solid #e0e0e0;
}

.size-label {
    display: flex;
    align-items: center;
    color: #666;
    font-weight: 500;
    font-size: 14px;
}

.label-text {
    margin-left: 4px;
}

.size-buttons {
    display: flex;
    gap: 8px;
}

.size-btn {
    font-size: 12px !important;
    font-weight: 500 !important;
    min-width: 90px;
}
</style>
